module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ZŠ Kostelec nad Orlicí","short_name":"zskostelec","start_url":"/","background_color":"#F46912","theme_color":"#FCB826","display":"minimal-ui","icon":"src/images/favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"295065083a805fb6e87b6cb428b8ee8b"},
    },{
      plugin: require('../node_modules/gatsby-plugin-ts-config/gatsby-browser.js'),
      options: {"plugins":[],"projectRoot":"/Users/jakubchadim/Projects/zskostelec/web","configDir":".gatsby"},
    }]
